"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixURLForPlatform = exports.githubHTMLUrlFromAPIUrl = exports.appBottomAnchorIfPossible = exports.getGitHubAvatarURLFromPayload = exports.getGitHubURLForSecurityAlert = exports.getGitHubURLForRepoInvitation = exports.getGitHubURLForRepoInvitationFromRepoURL = exports.getGitHubURLForRepo = exports.getGitHubURLForRelease = exports.getGitHubURLForBranch = exports.getGitHubSearchURL = exports.getGitHubURLForUser = exports.getRepoFullNameFromObject = exports.getRepoUrlFromOtherUrl = exports.getRepoUrlFromFullName = exports.getRepoFullNameFromUrl = exports.getBaseAPIUrlFromOtherAPIUrl = exports.getBaseUrlFromOtherUrl = exports.getReleaseIdFromUrl = exports.getIssueOrPullRequestNumberFromUrl = exports.getCommitCompareUrlFromRefs = exports.getCommitCompareUrlFromUrls = exports.getCommitUrlFromOtherUrl = exports.getCommitShaFromUrl = exports.getCommentIdFromUrl = exports.defaultBaseURL = void 0;
exports.defaultBaseURL = 'https://github.com';
function getCommentIdFromUrl(url) {
    if (!url)
        return null;
    const matches = url.match(/\/comments\/([0-9]+)([?].+)?$/);
    return (matches && matches[1] && parseInt(matches[1], 10)) || null;
}
exports.getCommentIdFromUrl = getCommentIdFromUrl;
function getCommitShaFromUrl(url) {
    if (!url)
        return undefined;
    const matches = url.match(/\/commits?\/([a-zA-Z0-9]+)([?].+)?$/);
    return (matches && matches[1]) || undefined;
}
exports.getCommitShaFromUrl = getCommitShaFromUrl;
function getCommitUrlFromOtherUrl(url) {
    if (!url)
        return;
    const repoURL = exports.getRepoUrlFromOtherUrl(url);
    if (!repoURL)
        return;
    const sha = getCommitShaFromUrl(url);
    if (!sha)
        return;
    return `${repoURL}/commit/${sha}`;
}
exports.getCommitUrlFromOtherUrl = getCommitUrlFromOtherUrl;
function getCommitCompareUrlFromUrls(commit1URL, commit2URL) {
    if (!(commit1URL && commit2URL))
        return;
    const repo1URL = exports.getRepoUrlFromOtherUrl(commit1URL);
    const repo2URL = exports.getRepoUrlFromOtherUrl(commit2URL);
    if (!(repo1URL && repo2URL && repo1URL === repo2URL))
        return;
    const sha1 = getCommitShaFromUrl(commit1URL);
    const sha2 = getCommitShaFromUrl(commit2URL);
    if (!(sha1 && sha2))
        return;
    return `${repo1URL}/compare/${sha1.substr(0, 7)}...${sha2.substr(0, 7)}`;
}
exports.getCommitCompareUrlFromUrls = getCommitCompareUrlFromUrls;
function getCommitCompareUrlFromRefs(before, head, { repoURL }) {
    if (!(before && head && repoURL))
        return;
    return `${repoURL}/compare/${before.substr(0, 7)}...${head.substr(0, 7)}`;
}
exports.getCommitCompareUrlFromRefs = getCommitCompareUrlFromRefs;
function getIssueOrPullRequestNumberFromUrl(url) {
    if (!url)
        return;
    const matches = url.match(/\/(issues|pulls)\/([0-9]+)([?].+)?$/);
    const issueOrPullRequestNumber = matches && matches[2];
    return ((issueOrPullRequestNumber && parseInt(issueOrPullRequestNumber, 10)) ||
        undefined);
}
exports.getIssueOrPullRequestNumberFromUrl = getIssueOrPullRequestNumberFromUrl;
function getReleaseIdFromUrl(url) {
    if (!url)
        return null;
    const matches = url.match(/\/releases\/([0-9]+)([?].+)?$/);
    return (matches && matches[1]) || null;
}
exports.getReleaseIdFromUrl = getReleaseIdFromUrl;
const getBaseUrlFromOtherUrl = (url) => {
    if (!(url && typeof url === 'string'))
        return undefined;
    return (((url.match(/([^:]+:\/\/[^\/]+)(\/(repos\/)?)([a-zA-Z0-9\-._]+\/[a-zA-Z0-9\-._]+[^/#$]?)/i) || [])[1] || '').replace('/api.', '/') || undefined);
};
exports.getBaseUrlFromOtherUrl = getBaseUrlFromOtherUrl;
const getBaseAPIUrlFromOtherAPIUrl = (apiURL) => {
    if (!(apiURL && typeof apiURL === 'string'))
        return undefined;
    const matches = apiURL.match(/([^:]+:\/\/[^\/]+)/i);
    return (matches && matches[0]) || undefined;
};
exports.getBaseAPIUrlFromOtherAPIUrl = getBaseAPIUrlFromOtherAPIUrl;
const getRepoFullNameFromUrl = (url) => url
    ? (url.match(/([^:]+:\/\/[^\/]+)(\/(repos\/)?)([a-zA-Z0-9\-._]+\/[a-zA-Z0-9\-._]+[^/#$]?)/i) || [])[4] || undefined
    : undefined;
exports.getRepoFullNameFromUrl = getRepoFullNameFromUrl;
const getRepoUrlFromFullName = (repoFullName, { baseURL = exports.defaultBaseURL } = {}) => {
    return baseURL && repoFullName && repoFullName.split('/').length === 2
        ? `${baseURL}/${repoFullName}`
        : undefined;
};
exports.getRepoUrlFromFullName = getRepoUrlFromFullName;
const getRepoUrlFromOtherUrl = (url) => {
    const baseURL = exports.getBaseUrlFromOtherUrl(url);
    const repoFullName = exports.getRepoFullNameFromUrl(url);
    return exports.getRepoUrlFromFullName(repoFullName || '', { baseURL });
};
exports.getRepoUrlFromOtherUrl = getRepoUrlFromOtherUrl;
const getRepoFullNameFromObject = (repo) => (repo &&
    ((repo.name && repo.name.includes('/') ? repo.name : undefined) ||
        (repo.full_name || exports.getRepoFullNameFromUrl(repo.html_url || repo.url)))) ||
    undefined;
exports.getRepoFullNameFromObject = getRepoFullNameFromObject;
const getGitHubURLForUser = (username, { baseURL = exports.defaultBaseURL, isBot, } = {}) => (username ? `${baseURL}/${isBot ? 'apps/' : ''}${username}` : undefined);
exports.getGitHubURLForUser = getGitHubURLForUser;
const objToQueryParams = (obj) => Object.keys(obj)
    .map(key => `${key}=${obj[key]}`)
    .join('&');
const getGitHubSearchURL = (queryParams, { baseURL = exports.defaultBaseURL } = {}) => (queryParams ? `${baseURL}/search?${objToQueryParams(queryParams)}` : '');
exports.getGitHubSearchURL = getGitHubSearchURL;
const getGitHubURLForBranch = (ownerName, repoName, branch, { baseURL = exports.defaultBaseURL } = {}) => ownerName && repoName && branch
    ? `${baseURL}/${ownerName}/${repoName}/tree/${branch}`
    : undefined;
exports.getGitHubURLForBranch = getGitHubURLForBranch;
const getGitHubURLForRelease = (ownerName, repoName, tagName, { baseURL = exports.defaultBaseURL } = {}) => ownerName && repoName
    ? tagName
        ? `${baseURL}/${ownerName}/${repoName}/releases/tag/${tagName}`
        : `${baseURL}/${ownerName}/${repoName}/releases`
    : '';
exports.getGitHubURLForRelease = getGitHubURLForRelease;
const getGitHubURLForRepo = (ownerName, repoName, { baseURL = exports.defaultBaseURL } = {}) => (ownerName && repoName ? `${baseURL}/${ownerName}/${repoName}` : undefined);
exports.getGitHubURLForRepo = getGitHubURLForRepo;
const getGitHubURLForRepoInvitationFromRepoURL = (repoURL) => {
    if (!repoURL)
        return undefined;
    return `${repoURL}/invitations`;
};
exports.getGitHubURLForRepoInvitationFromRepoURL = getGitHubURLForRepoInvitationFromRepoURL;
const getGitHubURLForRepoInvitation = (ownerName, repoName, { baseURL = exports.defaultBaseURL } = {}) => {
    if (!(ownerName && repoName))
        return undefined;
    return `${baseURL}/${ownerName}/${repoName}/invitations`;
};
exports.getGitHubURLForRepoInvitation = getGitHubURLForRepoInvitation;
const getGitHubURLForSecurityAlert = (repoURL) => repoURL ? `${repoURL}/network/alerts` : undefined;
exports.getGitHubURLForSecurityAlert = getGitHubURLForSecurityAlert;
const getGitHubAvatarURLFromPayload = (payload, userId) => {
    if (!payload)
        return undefined;
    const fields = Object.getOwnPropertyNames(payload);
    const fieldWithAvatar = fields.find(field => {
        const hasAvatar = payload[field] &&
            payload[field].user &&
            payload[field].user.avatar_url &&
            typeof payload[field].user.avatar_url === 'string';
        if (!hasAvatar)
            return false;
        if (userId && `${payload[field].user.id}` !== `${userId}`)
            return false;
        return true;
    });
    if (!fieldWithAvatar)
        return undefined;
    return payload[fieldWithAvatar].user.avatar_url;
};
exports.getGitHubAvatarURLFromPayload = getGitHubAvatarURLFromPayload;
function appBottomAnchorIfPossible(uri, isMobile) {
    if (!uri)
        return '';
    const anchorId = isMobile ? 'bottom' : 'partial-timeline';
    return uri.includes('#') ? uri : `${uri}#${anchorId}`;
}
exports.appBottomAnchorIfPossible = appBottomAnchorIfPossible;
function githubHTMLUrlFromAPIUrl(apiURL, isMobile, { addBottomAnchor, baseURL = exports.defaultBaseURL, commentId, commentIsInline, issueOrPullRequestNumber, tagName, } = {}) {
    if (!apiURL)
        return '';
    const [, type, restOfURL] = apiURL.match('api.github.com/([a-zA-Z]+)/(.*)');
    if (!(type && restOfURL))
        return '';
    if (type === 'repos') {
        const repoFullName = exports.getRepoFullNameFromUrl(apiURL);
        const [type2, ...restOfURL2] = (apiURL.split(`/repos/${repoFullName}/`)[1] || '').split('/');
        if (restOfURL2[0]) {
            switch (type2) {
                case 'comments':
                    return undefined;
                case 'commits': {
                    if (commentId) {
                        return `${baseURL}/${repoFullName}/commit/${restOfURL2[0]}#${commentIsInline ? 'r' : 'commitcomment-'}${commentId}`;
                    }
                    return `${baseURL}/${repoFullName}/commit/${restOfURL2.join('/')}`;
                }
                case 'issues':
                    if (issueOrPullRequestNumber &&
                        (commentId || (restOfURL2[0] === 'comments' && restOfURL2[1]))) {
                        return `${baseURL}/${repoFullName}/issues/${issueOrPullRequestNumber}#issuecomment-${commentId ||
                            restOfURL2[1]}`;
                    }
                    return `${baseURL}/${repoFullName}/issues/${restOfURL2.join('/')}`;
                case 'pulls':
                    if (issueOrPullRequestNumber &&
                        (commentId || (restOfURL2[0] === 'comments' && restOfURL2[1]))) {
                        return `${baseURL}/${repoFullName}/pull/${issueOrPullRequestNumber}#${commentIsInline ? 'discussion_r' : 'issuecomment-'}${commentId || restOfURL2[1]}`;
                    }
                    return `${baseURL}/${repoFullName}/pull/${restOfURL2.join('/')}`;
                case 'releases':
                    // it wont go directly to the release, but to the generic releases page.
                    // we would need to have the tag name to do that.
                    return `${baseURL}/${repoFullName}/releases${tagName ? `/tag/${tagName}` : ''}`;
                default:
                    return `${baseURL}/${restOfURL}`;
            }
        }
    }
    const uri = `${baseURL}/${restOfURL}`;
    return addBottomAnchor ? appBottomAnchorIfPossible(uri, isMobile) : uri;
}
exports.githubHTMLUrlFromAPIUrl = githubHTMLUrlFromAPIUrl;
function fixURLForPlatform(url, isMobile, options) {
    if (!url)
        return '';
    // sometimes the url come like this: '/facebook/react', so we add https://github.com
    const baseURL = (options && options.baseURL) || exports.defaultBaseURL;
    let uri = url[0] === '/' && url.indexOf('github.com') < 0 ? `${baseURL}${url}` : url;
    if (uri.indexOf('api.github.com') >= 0)
        uri = githubHTMLUrlFromAPIUrl(uri, isMobile, options);
    if (options && options.commentIsInline && uri)
        uri = uri.replace('commitcomment-', 'r');
    return options && options.addBottomAnchor && uri
        ? appBottomAnchorIfPossible(uri, isMobile)
        : uri;
}
exports.fixURLForPlatform = fixURLForPlatform;
//# sourceMappingURL=url.js.map